import { Grid, Typography } from "@mui/material"
import type { orderItem as OrderItemType } from './VerificationType'

type configType = {
  service_number: string
}

const labelStyle = { color: '#7A97B0', fontSize: '14px!important', fontWeight: 400 }
const valueStyle = { fontWeight: 500, fontSize: '14px!important', color: '#242424' }

const CommscodeConfig = ({ orderItem }: { orderItem: OrderItemType }) => {
  const config: configType = orderItem.config

  return <Grid container spacing={1.5}>
    <Grid item sm={4}>
      <Typography sx={labelStyle}>Service Number</Typography>
      <Typography sx={valueStyle}>{config.service_number}</Typography>
    </Grid>
  </Grid>
}

export default CommscodeConfig
